const namespace = 'bravissimo/mastectomy-vat-exemption-request';

export const MASTECTOMY_VAT_EXEMPTION_REQUEST = `${namespace}/MASTECTOMY_VAT_EXEMPTION_REQUEST`;
export const MASTECTOMY_VAT_EXEMPTION_REQUEST_SUCCEEDED = `${namespace}/MASTECTOMY_VAT_EXEMPTION_REQUEST_SUCCEEDED`;
export const MASTECTOMY_VAT_EXEMPTION_REQUEST_FAILED = `${namespace}/MASTECTOMY_VAT_EXEMPTION_REQUEST_FAILED`;
export const CLOSE_MESSAGES = `${namespace}/CLOSE_MESSAGES`;
